import React, {
    useEffect, useState, useContext, useCallback
} from 'react';
import {  withRouter,useLocation } from 'react-router-dom';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import { formatCurrency, Icon, Loader } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { isCapabilityEnabled, getNormalizedLOBName } from '@xengage/gw-portals-config-js';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { PolicyService } from 'gw-capability-policy';
import { DocumentService } from 'gw-capability-policydocument';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { FormattedDate, IntlContext } from 'react-intl';
import { LoaderExt  } from 'gw-components-platform-react';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import moment from 'moment';
import {
    PolicyCommonDetails,
    PolicyCommonDocuments,
    PolicyCommonContacts,
    PolicyCoverages
} from '../../../components/cpmi_Policy-Common';
import metadata from './PolicyDetails.metadata.json5';
import messages from './PolicyDetails.messages';
import styles from './PolicyDetails.module.scss';
import usecpmiAnalytics from '../../../hooks/usecpmiAnalytics';
import useGoogleAnalytics from '../../../hooks/useGoogleAnalytics';


import { Button } from '@jutro/legacy/components';


import { Link } from '@jutro/router';


const handlePrint = () => {
    window.print();
};

function PolicyDetails(props) {
    const { history, match,location:state } = props;
    
    const location = useLocation();
    
    const{ state:{
        term,policyNumber,effective,expiration,isODSPolicy
    }} = location;
    const { authHeader } = useAuthentication();
    const [policyCommonDetails, updatePolicyCommonDetails] = useState({
        currentPeriodDetails: {},
        renewedPeriodDetails: {},
        hasRenewedPeriod: false,
        policyDetails:{}
    });
    const [writableDocuments, updateWritableDocuments] = useState([]);
    const [documentsArray, updateDocumentArray] = useState([]);
    const [loading, setLoading] = useState(true);
    const translator = useTranslator();
    const { capabilitiesConfig } = appConfig;
    
    // const policyNumber = _.get(match, 'params.policyNumber');
    const [trackPageView,trackEvent] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();

    useEffect(() => {
        trackGAPageView("Policy Details","/account-policy-details/policynum")
    },[])
    const getPolicyData = useCallback(async () => {
       
        // const policyDetails = await PolicyService.getAccountPolicyDetails(policyNumber, authHeader);
        let policyDetailsData = [
            policyNumber,
            term,
            isODSPolicy,
            effective,
            expiration
        ]
        const policyDetails = await PolicyService.getPolicyDetails(policyDetailsData,authHeader);
       
        updateDocumentArray(policyDetails.documents);

        updatePolicyCommonDetails({
            currentPeriodDetails: policyDetails,
            renewedPeriodDetails: policyDetails.renewedPeriod ? policyDetails.renewedPeriod : {},
            hasRenewedPeriod: !_.isEmpty(policyDetails.renewedPeriod),
            policyDetails:policyDetails
        });
        setLoading(false);
    }, [policyNumber, term, isODSPolicy, effective, expiration, authHeader]);

    const redirectToEndorsement = useCallback(
        (policyDetails, requestType) => {
            const productCode = _.findKey(policyDetails.lobs, (lob) => !_.isEmpty(lob));
            history.push(`/endorsement-${getNormalizedLOBName(productCode)}`,
                { policyNumber, policyDetails, requestType });
        },
        [history, policyNumber]
    );

    const canChangePolicy = useCallback(
        (policyPeriod) => {
            if (!_.isEmpty(policyPeriod)) {
                const productCode = _.findKey(policyPeriod.lobs, (lob) => !_.isEmpty(lob));
                if (_.isEmpty(productCode)) {
                    return false;
                }
                return (
                    isCapabilityEnabled({
                        capabilitiesConfig,
                        capabilityName: 'policychange',
                        lob: productCode
                    }) && policyPeriod.canBeChanged
                );
            }
            return false;
        },
        [capabilitiesConfig]
    );

    const getPolicyDownloadLink = useCallback(() => {
        return DocumentService.downloadPolicyDocument(
            _.get(policyCommonDetails.currentPeriodDetails, 'idCardPublicID'),
            _.get(policyCommonDetails.currentPeriodDetails, 'idCardSessionID')
        );
    }, [policyCommonDetails]);

    

    const getPolicyDownload = (item, index, property) => {
        return (
           
            <button
                id={index}
                onClick={(e) => {
                   
                    e.preventDefault()
                    window.open(DocumentService.downloadPolicyDocument(item.docUID,item.sessionID))
                    //const a = document.createElement("a");
                    // a.setAttribute("href", res);
                    // document.body.appendChild(a);
                    // a.click();
                }}
                    
                            
                style={{ display: "block" }}
                className={styles.PDFButton}
            >
                <Icon icon="cust-file-solid" />
                PDF
            </button>
        );
    };

    useEffect(
        () => {
            try {
                getPolicyData();
            } catch (e) {
                throw new Error(e);
            }
        },
        // Only need to run once when initial page render and when documents are added/removed
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [writableDocuments.length]
    );

    const backToPolicies = () => {
        trackEvent("Back to Policies","/policiespage")
        history.goBack();
    }

    const getPolicyType=(value)=>{
        
        if(value==="Workers' Compensation (v7)"){
            return "Workers' Compensation"
        } 
        
        if(value==="General Liability (v7)"){
            return "General Liability"
        }
        
        if(value==="Commercial Auto (v7)"){
            return "Commercial Auto"
        }
        
        if(value==="Commercial Property (v7)"){
            return "Commercial Property"
        }
        
        if(value==="Commercial Package (v7)"){
            return "Commercial Package"
        }

        return value
    }
    const renderPolicyHeading= () => {
        
        const productName =  getPolicyType(policyCommonDetails.policyDetails.productName)
        return (
            <div>
                {/* <Icon icon="cust-angle-double-left-solid"  onClick={backToPolicies} className={styles.backButton}/> */}
                <div style={{marginBottom:"28px"}}><span className={styles.myprofilebutton} onClick={backToPolicies}>{"<<"}</span></div>
                <p>{productName} {policyCommonDetails.policyDetails.policyNumber}</p>
                {/* <button className="policyHeadingBtn">In Force</button> TO BE REMOVED ONCE STATUS IS COMING FROM BACKEND */}
                <button className="policyHeadingBtn">{policyCommonDetails.policyDetails.displayStatus}</button> 
            </div>
            
        )
    }

    const getDateSorted=useCallback((a,b)=>{
        
        return new Date(LocalDateUtil.toMidnightDate(a)) - new Date(LocalDateUtil.toMidnightDate(b));
    },[])

    const getStringSort =useCallback((a,b)=>{
        return a.localeCompare(b)
    },[])

    const intlContext = useContext(IntlContext);
    const getTotalPremium = ((currentPeriod) =>{
        
        if(!_.isEmpty(currentPeriod.cost)){
            const formattedCurrency = formatCurrency(intlContext, { value:  currentPeriod.cost.amount, currency: currentPeriod.cost.currency, showFractions: true });
            return `${formattedCurrency}`;
        }
    })

    const getPolicyAddress = useCallback((policyContacts) =>{
        if(!_.isEmpty(policyContacts))
        {
            return (
                <div>
                    <p>{Object.values(policyContacts)[0].contact.primaryAddress.addressLine1}<br/>
                        {Object.values(policyContacts)[0].contact.primaryAddress.city},&nbsp;
                        {Object.values(policyContacts)[0].contact.primaryAddress.state}&nbsp;
                        {Object.values(policyContacts)[0].contact.primaryAddress.postalCode}</p>
                </div>
            )
        }
    })

    const getFormattedDateColumn = useCallback((item, index, property) => {
        return  moment(item[property.id]).format('MM/DD/YYYY');
    }, []);
    
    const getCell = (item, index, property) => {
        return item[property.id];
    };

    const getFormattedDate = ((value) => {
      
        const intl = useContext(IntlContext);
        let fmtvalue = intl.formatDate(intl.formatDate(moment(value).toDate().toUTCString(), { year: 'numeric', month: 'numeric', day: 'numeric' }));
        return <FormattedDate value={fmtvalue} format="vshort" />;
    })

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const renderCoveragesMessage = (()=>{
        // const textValue = policyCommonDetails?.policyDetails?.productName
        // textValue !=="Workers' Compensation (v7)" || policyCommonDetails?.policyDetails?.productName !=="Maritime Employers Liability"
        // return 
    })

    const renderCoverages =(()=>{

    })
    const overrideProps = {
        pageTitle: {
            content: renderPolicyHeading()
        },
        currentPeriod: {
            heading: translator(messages.currentTab)
        },
        renewalPeriod: {
            heading: policyCommonDetails.hasRenewedPeriod ? translator(messages.renewalTab) : '',
            disabled: !policyCommonDetails.hasRenewedPeriod
        },
        policyChangeButtonContainer: {
            visible: canChangePolicy(
                policyCommonDetails.policyDetails,
                policyCommonDetails.policyDetails.productName
            )
        },
        renewalPolicyChangeButtonContainer: {
            visible: canChangePolicy(
                policyCommonDetails.renewedPeriodDetails,
                policyCommonDetails.policyDetails.productName
            )
        },
        idCardContainer: {
            visible: !_.isEmpty(_.get(policyCommonDetails.policyDetails, 'idCardPublicID'))
        },
        idCard: {
            href: getPolicyDownloadLink(),
            target: '_blank'
        },
        policyDocumentsSection: {
            updateWritableDocuments: updateWritableDocuments,
            writableDocuments: writableDocuments,
            data:documentsArray
        },
        policyStart:{
            // value:intlContext.formatDate(new Date(policyCommonDetails.policyDetails.effective), { year: 'numeric', month: 'short', day: 'numeric'  },{format:'vshort'})
            value: moment(policyCommonDetails.policyDetails.effectiveDate).format('MM/DD/YYYY')
        },
        policyExpiration:{
            value:moment(policyCommonDetails.policyDetails.expirationDate).format('MM/DD/YYYY')
        },
        totalPremium:{
            value:getTotalPremium(policyCommonDetails.policyDetails)
        },
        policyAddressValue:{
            value:getPolicyAddress(policyCommonDetails.policyDetails.contacts)
        },
        producer:{
            value:policyCommonDetails.policyDetails.producerCodeOfServiceOrg
        },
        policyCancellationDate:{
            visible:policyCommonDetails.policyDetails.displayStatus === 'Pending Cancellation' ||
                    policyCommonDetails.policyDetails.displayStatus === 'Cancellation' ||
                    policyCommonDetails.policyDetails.displayStatus === 'Canceled',
            value:getFormattedDate(policyCommonDetails.policyDetails.cancellationDate)
        },
        policyCancellationReason: {
            visible:policyCommonDetails.policyDetails.displayStatus === 'Pending Cancellation' ||
            policyCommonDetails.policyDetails.displayStatus === 'Cancellation' ||
            policyCommonDetails.policyDetails.displayStatus === 'Canceled',
            value: policyCommonDetails.policyDetails.cancellationReason
        },
        tablePaymentScheduleDetail:{
            data:documentsArray
        },
        tablePaymentScheduleDetailDueDate:{
            onSort:getDateSorted
        },
        tablePaymentDescription:{
            onSort:getStringSort
        },
        coverablesPnc: {
            visible:(policyCommonDetails?.policyDetails?.productName !=="Workers' Compensation (v7)" && policyCommonDetails?.policyDetails?.productName !=="Maritime Employers Liability"),
        },
        policyCoveragesSection:{
            visible: (policyCommonDetails?.policyDetails?.productName === "Workers' Compensation (v7)" || policyCommonDetails?.policyDetails?.productName ==="Maritime Employers Liability"), 
        }
        
    };

    const resolvers = {
        resolveComponentMap: {
            policycommondetailscomponent: PolicyCommonDetails,
            policycoveragescomponent: PolicyCoverages,
            policycommondocumentscomponent: PolicyCommonDocuments,
            policycommoncontactscomponent: PolicyCommonContacts,

        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onPrint: handlePrint,
            getDateSorted:getDateSorted,
            onChangePolicy: () => redirectToEndorsement(policyCommonDetails.policyDetails, 'policyChange'),
            onChangePolicyRenewal: () => redirectToEndorsement(
                policyCommonDetails.renewedPeriodDetails, 'policyRenew'
            ),
            getCell:getCell,
            getFormattedDateColumn:getFormattedDateColumn,
            getPolicyDownload:getPolicyDownload
        }
    };
    if(loading)
    {
        return (<LoaderExt loading={!loading}/>)
    }

    return (
        
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={policyCommonDetails}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
        />
       
    );
}
PolicyDetails.propTypes = {
    match: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    location: PropTypes.shape({
        productCode: PropTypes.string
    }).isRequired
};

export default withRouter(PolicyDetails);